export type ModuleIdentityMode = "off" | "subtle";

const MODULE_ACCENTS: Array<{ match: string[]; accent: string }> = [
  { match: ["/contributions", "/pledges", "/funds", "/finance"], accent: "var(--success-500)" },
  { match: ["/community", "/directory", "/people"], accent: "var(--info-500)" },
  { match: ["/hr"], accent: "var(--warning-500)" },
  { match: ["/attendance", "/services", "/volunteers", "/kids-check-in"], accent: "var(--info-500)" },
  { match: ["/requests", "/projects", "/tasks", "/assets"], accent: "var(--info-500)" },
  { match: ["/messaging"], accent: "var(--info-500)" },
  { match: ["/calendar"], accent: "var(--info-500)" },
  { match: ["/reports"], accent: "var(--warning-500)" },
  { match: ["/member"], accent: "var(--info-500)" },
];

export const getModuleAccent = (pathname: string) => {
  const match = MODULE_ACCENTS.find((entry) =>
    entry.match.some((prefix) => pathname === prefix || pathname.startsWith(`${prefix}/`)),
  );
  return match?.accent ?? "var(--info-500)";
};
